var _defs, _rect, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374.5 38.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #333;\n        fill-opacity: .2;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #2a0000;\n      }\n\n      .st2, .st3 {\n        display: none;\n      }\n\n      .st4 {\n        fill: #1a1a1a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 169.1,
    y: -36.2,
    width: 427.9,
    height: 104.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,38.6c-2.5,0-4.5-.5-6-1.6-1.5-1.1-2.5-2.6-3.2-4.5-.6-1.9-.9-4.2-.9-6.8v-12.5c0-2.7.3-5,1-6.9.6-1.9,1.8-3.4,3.4-4.5C6,.8,8.2.2,10.9.2s4.8.4,6.3,1.3c1.6.9,2.7,2.1,3.3,3.8.7,1.6,1,3.6,1,5.8v2.2h-7.4v-2.6c0-1,0-1.8-.2-2.6-.1-.8-.4-1.3-.9-1.8-.4-.4-1.2-.6-2.1-.6s-1.8.3-2.2.8c-.5.5-.8,1.2-.9,2-.1.8-.2,1.7-.2,2.6v16.5c0,1,0,2,.3,2.8s.5,1.5,1,1.9c.5.5,1.2.7,2.2.7s1.7-.2,2.2-.7c.5-.5.9-1.2,1.1-2,.2-.8.3-1.8.3-2.9v-4h-3.6v-4.6h10.5v19.2h-5l-.5-3.4c-.5,1.1-1.2,2.1-2.2,2.8-1,.7-2.3,1.1-4,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,38V.7h9.7c2.5,0,4.7.3,6.5.9,1.8.6,3.2,1.6,4.1,3,1,1.4,1.5,3.4,1.5,6s-.1,2.9-.4,4.1c-.3,1.2-.7,2.2-1.4,3.1-.7.9-1.6,1.6-2.8,2.1l5.2,18.2h-7.8l-4.3-16.9h-2.7v16.9h-7.6ZM33.8,16.6h2.2c1.2,0,2.2-.2,2.9-.6.7-.4,1.2-1,1.5-1.8.3-.8.4-1.8.4-3,0-1.7-.3-3-.9-3.9-.6-.9-1.8-1.4-3.5-1.4h-2.6v10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,38V.7h7.6v37.3h-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,38v-4.7l9.5-27.4h-9V.7h16.6v4.1l-9.8,28h9.8v5.2h-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.6,38v-4.7l9.5-27.4h-9V.7h16.6v4.1l-9.8,28h9.8v5.2h-17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,38V.7h7.6v32.1h8.8v5.2h-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.2,38v-14.8L115.9.7h7.1l4,13.1,3.7-13.1h6.9l-7.2,22.5v14.8h-7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.4,38V6.4h-5.8V.7h19.1v5.7h-5.7v31.6h-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.4,38V.7h9.7c2.5,0,4.7.3,6.5.9,1.8.6,3.2,1.6,4.1,3,1,1.4,1.5,3.4,1.5,6s-.1,2.9-.4,4.1c-.3,1.2-.7,2.2-1.4,3.1-.7.9-1.6,1.6-2.8,2.1l5.2,18.2h-7.8l-4.3-16.9h-2.7v16.9h-7.6ZM178,16.6h2.2c1.2,0,2.2-.2,2.9-.6.7-.4,1.2-1,1.5-1.8.3-.8.4-1.8.4-3,0-1.7-.3-3-.9-3.9-.6-.9-1.8-1.4-3.5-1.4h-2.6v10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.5,38V.7h16.3v5.3h-8.7v9.9h6.7v5.3h-6.7v11.7h8.8v5.2h-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.9,38V.7h16.3v5.3h-8.7v9.9h6.7v5.3h-6.7v11.7h8.8v5.2h-16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.5,38.5c-2.8,0-5-.5-6.6-1.6-1.6-1-2.7-2.5-3.4-4.4-.6-1.9-1-4-1-6.5v-13.4c0-2.6.3-4.8,1-6.7.6-1.9,1.8-3.3,3.4-4.3,1.6-1,3.8-1.5,6.6-1.5s4.8.4,6.3,1.3c1.5.9,2.6,2.1,3.2,3.8.6,1.6.9,3.5.9,5.7v3.1h-7.4v-3.5c0-.9,0-1.7-.1-2.4,0-.8-.3-1.4-.8-1.8-.4-.5-1.1-.7-2.1-.7s-1.7.2-2.2.7c-.5.5-.8,1.1-.9,1.9-.1.8-.2,1.7-.2,2.6v16.9c0,1,0,2,.3,2.7.2.8.5,1.4,1,1.8.5.4,1.2.6,2.1.6s1.7-.2,2.1-.7c.4-.5.7-1.1.8-1.9.1-.8.2-1.6.2-2.5v-3.6h7.4v3.1c0,2.2-.3,4.1-.9,5.8-.6,1.7-1.7,3-3.2,4-1.5,1-3.6,1.5-6.4,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.3,38.5c-2.7,0-4.9-.5-6.5-1.5-1.6-1-2.7-2.4-3.4-4.2-.7-1.8-1-4-1-6.6v-13.9c0-2.5.3-4.7,1-6.5.7-1.8,1.8-3.2,3.4-4.1,1.6-1,3.8-1.4,6.5-1.4s5,.5,6.6,1.5c1.6,1,2.8,2.3,3.5,4.1.7,1.8,1,4,1,6.5v13.9c0,2.5-.3,4.7-1,6.6-.7,1.8-1.8,3.2-3.5,4.2-1.6,1-3.8,1.5-6.6,1.5ZM281.3,33c1,0,1.7-.2,2.2-.7.5-.4.8-1,.9-1.8.2-.8.2-1.6.2-2.4V10.5c0-.9,0-1.7-.2-2.4-.2-.7-.5-1.3-.9-1.8-.5-.4-1.2-.7-2.2-.7s-1.6.2-2.1.7c-.5.4-.8,1-.9,1.8-.2.7-.2,1.5-.2,2.4v17.6c0,.9,0,1.7.2,2.4.1.8.4,1.4.9,1.8.5.4,1.2.7,2.1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.3,38v-6.8h6.6v6.8h-6.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.2,16.3l.3-16.2h3.5l2,10.2,2.1-10.2h3.4l.3,16.2h-2.4l-.3-11-2.1,11h-2.1l-2.2-11.1-.2,11.1h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.4,16.3V.1h3.3v16.2h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.3,16.3V.1h2.3l3.6,8.4V.1h2.7v16.2h-2.2l-3.6-9v9h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.6,16.3V.1h4c1.4,0,2.4.2,3.2.5.8.4,1.3.9,1.6,1.7s.5,1.7.5,2.9v5.9c0,1.2-.2,2.2-.5,3s-.9,1.3-1.6,1.7c-.8.4-1.8.5-3.2.5h-4ZM340.9,14h.7c.6,0,1,0,1.3-.3.3-.2.4-.5.5-.9,0-.4.1-.8.1-1.4v-6.7c0-.6,0-1-.1-1.4,0-.3-.3-.6-.5-.8-.3-.2-.7-.2-1.3-.2h-.7v11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.2,16.3V.1h7.1v2.3h-3.8v4.3h2.9v2.3h-2.9v5.1h3.8v2.2h-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.1,16.3V.1h2.3l3.6,8.4V.1h2.7v16.2h-2.2l-3.6-9v9h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.4,19.1l-.2-1c.3-.1.7-.3.9-.6.3-.3.4-.7.4-1.2h-1.6v-2.9h2.9v2.6c0,.9-.2,1.7-.6,2.2s-1,.8-1.8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.5,38.3v-18.6h2.6l4.1,9.7v-9.7h3.1v18.6h-2.5l-4.1-10.3v10.3h-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.3,38.3v-18.6h8.1v2.6h-4.3v4.9h3.3v2.6h-3.3v5.8h4.4v2.6h-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333,38.3l-3.5-18.6h3.3l2.2,12.9,2.1-12.9h3.4l-3.5,18.6h-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,38.3l3.6-18.6h4.2l3.6,18.6h-3.5l-.7-4.1h-2.9l-.7,4.1h-3.6ZM344.3,31.9h2.2l-1.1-7.5-1.1,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352,38.3v-18.6h4.6c1.6,0,2.8.2,3.7.6s1.5,1,1.9,1.9.6,2,.6,3.3v6.8c0,1.4-.2,2.5-.6,3.4-.4.9-1,1.5-1.9,2s-2.1.6-3.6.6h-4.6ZM355.8,35.7h.8c.7,0,1.2-.1,1.5-.3.3-.2.5-.6.6-1,0-.4.1-1,.1-1.6v-7.7c0-.6,0-1.2-.1-1.6-.1-.4-.3-.7-.6-.9s-.8-.3-1.5-.3h-.8v13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.1,38.3l3.6-18.6h4.2l3.6,18.6h-3.5l-.7-4.1h-2.9l-.7,4.1h-3.6ZM367.7,31.9h2.2l-1.1-7.5-1.1,7.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.6,27.7l8.1-2v4.2c-.1,0,8.2,0,8.2,0l-3.7-11.6h-7.6c3.9-5,8.3-10.2,16.4-11.8l1.4-4.1-6.2.2-.5-1.1h-7.6c0,0-3-1.5-3-1.5,0,0-1.2,1.9,0,3.2,0,0-6.4,3.2-13.9,4-.5,0-.9,0-1.4.1,5.1,0,9,0,18.2-3.5l-.3-.5h6.9c0,0,.6,1.2.6,1.2l4.7-.2-.2.5c-11,2.6-14.1,10.2-20.8,17.5,0,0,1.5-5.5-.7-10.8,0,0,1.5,7.4-3.8,15.5,0,0-3.5-3.4-4.3-8.4,0,0-.4,4.5,1.3,7.5l-7.1-.4s-1.1-7.6-5.6-12.3c0,0,5.6,10.6-.8,19.5h0c-1.8-2.2-4.4-3.7-6.9-5.2-1.2-.8-2.6-1.6-3.6-2.7-6.2-6.3-.8-17,8.8-17.6h-1.8c-6,0-10.3,4.4-11.2,9.5,0,.3,0,.6-.1,1-.5,2.6-2.3,6.5-8.1,9.8l4.4,10.5h9.7l-3-5.2,4-3.7c3.7,2.4,7.9,4.5,7.9,8.9h10.7c-.2-2.7-1.4-5.7-3-8.6h5c1.3,2.9,3,5.8,4.7,8.6h8.2c-1.5-2.8-3-6.9-3.7-10.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.8,33,402.7,17.6c0,4.2-3.4,7.6-7.6,7.6s-6.8-2.7-7.5-6.2c0,2.1.9,4.3,2.6,6.1,1,1,2.4,1.9,3.6,2.7,2.4,1.5,5.1,3.1,6.9,5.2,4.5-6.3,3.1-13.4,1.8-17.1.1.5.2,1.1.2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.3,19.4c1.4,3.4,1.9,6.4,1.9,6.4l7.1.4c-.3-.6-.6-1.3-.8-2-1.8-.2-5.2-1-8.2-4.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.3,22.9c1.3,2.7,2.9,4.3,2.9,4.3,5.3-8.1,3.8-15.5,3.8-15.5,0,0,.5,7.8-6.8,11.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.2,15.7c.5,3.7-.3,6.7-.3,6.7,6.7-7.3,9.8-14.9,20.8-17.5,0,0-8.3,1.3-13.6,7.3l1.9-3.5s-5.6,4.3-8.8,7Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_1937048025888",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M405.1,16.4s-5.3,7.3-15.9,9.5c0,0,.4-8.8,6.1-16.3,0,0,16.5.1,25.9-6,0,0-10.7,3.8-27.9.8,0,0-7.7,5.3-10.5,16.7l1.7-.7s0,4.2-2,9.4l1.5,8.6h9.3s-.1-2.8-2.8-3.4c0-7,12.5-9.3,14.6-18.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420.3,28.3s-4.6-4.8-4.6-13.2c0,0-4.4,6.4-.9,13.2l5.1,10.1h9.2s-.6-2.2-3.5-4.1c0,0-1.9-6.2,3.9-12.3v1.8s4.4-5.4,9.5-8.1l-5.8-1.3s-5.1,2.1-11.3,7.3l2.6-.2c-1.7,1.8-3.2,4.1-4.3,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M439.7,15.6c-6.9,1.7-10.4-1.6-10.2-6,0,0,3.7,4,9,3.2l10.2-1.5v-3.7l-11.8-4.2s-1.3,2.5-.3,4.8c0,0-3.2-.2-2.6-3.8l.5-2.5c.2-1.2,1.1-2.1,2.8-1.4l13.7,5.5v6.8s-11.3,2.8-11.3,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M421.6.4s7,2.1,14.1,2.7l-.6,2.9s-8.4-1.6-13.5-5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.9,26.4s-11.4,1-19.6-2l-4.7,3.5s6.7,3.1,17.5,3.9l-3-1.8s5.4.4,11.1-.3l-1.3-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M429,33.1l3.4,5.3h9.6s-.5-2.9-4.7-3.6c-2.1-3.2-2.6-10.2-1-14.8-4.3,2.2-10.3,8.5-7.3,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M394.9,32.4s.7,2.9,1.8,5.9h8.8s.2-2.8-3.4-3.1l.6-2.8-5.7-1-2.1,1.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.4,36c14.5,0,27.8.9,38.4,2.3h-76.8c10.6-1.5,23.9-2.3,38.4-2.3Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_19370480258881",
    "data-name": "_1937048025888",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-48.8,16.8s-5.3,7.3-15.9,9.5c0,0,.4-8.8,6.1-16.3,0,0,16.5.1,25.9-6,0,0-10.7,3.8-27.9.8,0,0-7.7,5.3-10.5,16.7l1.7-.7s0,4.2-2,9.4l1.5,8.6h9.3s-.1-2.8-2.8-3.4c0-7,12.5-9.3,14.6-18.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-33.5,28.7s-4.6-4.8-4.6-13.2c0,0-4.4,6.4-.9,13.2l5.1,10.1h9.2s-.6-2.2-3.5-4.1c0,0-1.9-6.2,3.9-12.3v1.8s4.4-5.4,9.5-8.1l-5.8-1.3s-5.1,2.1-11.3,7.3l2.6-.2c-1.7,1.8-3.2,4.1-4.3,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-14.1,16c-6.9,1.7-10.4-1.6-10.2-6,0,0,3.7,4,9,3.2l10.2-1.5v-3.7l-11.8-4.2s-1.3,2.5-.3,4.8c0,0-3.2-.2-2.6-3.8l.5-2.5c.2-1.2,1.1-2.1,2.8-1.4L-2.8,6.4v6.8s-11.3,2.8-11.3,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-32.2.8s7,2.1,14.1,2.7l-.6,2.9s-8.4-1.6-13.5-5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-37.9,26.8s-11.4,1-19.6-2l-4.7,3.5s6.7,3.1,17.5,3.9l-3-1.8s5.4.4,11.1-.3l-1.3-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-24.9,33.5l3.4,5.3h9.6s-.5-2.9-4.7-3.6c-2.1-3.2-2.6-10.2-1-14.8-4.3,2.2-10.3,8.5-7.3,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-59,32.9s.7,2.9,1.8,5.9h8.8s.2-2.8-3.4-3.1l.6-2.8-5.7-1-2.1,1.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-38.4,36.5c14.5,0,27.8.9,38.4,2.3h-76.8c10.6-1.5,23.9-2.3,38.4-2.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c6771f7576f1fc97d6f92f9c18410b39.svg";
export { ForwardRef as ReactComponent };